class HttpError extends Error {
    constructor(status, statusText, body) {
        super(`${status} ${statusText}`);
        this.status = status;
        this.statusText = statusText;
        this.body = body;
    }
}
export default HttpError;
